<div class="px-3 rounded-3 bg-white">
  <b>{{this.model()}}</b>
  @if (this.usageStats().length > 0) {
  <div>
    <div class="row">
      <div class="col-12 col-lg-6">
        <span i18n="@@api-requests">API-Requests</span>&nbsp;<small class="text-muted">{{this.totalRequests}}</small>
        <apx-chart
          [series]="this.requestSeries"
          [chart]="{
            type: 'area',
            height: 350,
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          }"
          [xaxis]="this.xaxis"
          [yaxis]="{
            tickAmount: this.calculateRequestsToTickAmount()
          }"
          [dataLabels]="{
            enabled: false
          }"
          [tooltip]="this.requestTooltip"
        ></apx-chart>
      </div>
      <div class="col-12 col-lg-6">
        <span>
          @switch ($any(this.model())) {
          @case ('gpt-4o') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-4o-mini') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-4.1') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-4.1-mini') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-4.1-nano') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5-mini') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5-nano') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.1') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.2') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.4') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.4-mini') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.4-nano') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.5') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.5-pro') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.6') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.6-sol') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.6-terra') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-5.6-luna') {
          <span i18n="@@token">Token</span>
          }
          @case ('gpt-6-astra') {
          <span i18n="@@token">Token</span>
          }
          @case ('deepseek-r1:8b') {
          <span i18n="@@token">Token</span>
          }
          @case ('deepseek-r1:14b') {
          <span i18n="@@token">Token</span>
          }
          @case ('gemma3:4b') {
          <span i18n="@@token">Token</span>
          }
          @case ('llama3.2:3b') {
          <span i18n="@@token">Token</span>
          }
          @case ('mistral:7b') {
          <span i18n="@@token">Token</span>
          }
          @case ('qwen2.5vl:7b') {
          <span i18n="@@token">Token</span>
          }
          @case ('tts-1') {
          <span i18n="@@chars">Buchstaben</span>
          }
          @case ('tts-1-hd') {
          <span i18n="@@chars">Buchstaben</span>
          }
          @case ('gpt-4o-mini-tts') {
          <span i18n="@@chars">Buchstaben</span>
          }
          @case ('heygen_streaming_avatar') {
          <span i18n="@@time-in-seconds">Zeit in Sekunden</span>
          }
          @default {
          <span i18n="@@model-not-found">Model not found</span>
          }
          }
        </span>&nbsp;
        <small class="text-muted">{{this.totalValue}}</small>
        <apx-chart
          [series]="this.valueSeries"
          [chart]="{
            type: 'bar',
            height: 350,
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          }"
          [xaxis]="xaxis"
          [dataLabels]="{
            enabled: false
          }"
          [tooltip]="this.tokenTooltip"
        ></apx-chart>
      </div>
    </div>
  </div>
  } @else {
  <div [@.disabled]="true">
    <p-message
      severity="secondary"
      [closable]="false"
      i18n="@@not-enough-data"
    >Nicht genügend Daten zum auswerten!
    </p-message>
  </div>
  }
</div>